import { makeStyles } from '@material-ui/core';

// The wordmark, straight from the portal's public/ — the dark variant, because
// the sidebar it sits in is dark in both app themes. Served as a static asset
// rather than inlined as JSX so updating the brand is a file copy.
const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 26,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src="/logo-fullname-dark.svg" alt="" />;
};
